import { Table } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export const PendingTable = ({ data, FlooringCases, pagePermission }) => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Application ID",
      dataIndex: "application_uniqueId",
      key: "application_uniqueId",
      width: 120,
    },
    {
      title: "Date & Time",
      dataIndex: "submitted_date",
      key: "submitted_date",
      width: 110,
    },
    {
      title: "Flooring Type",
      dataIndex: "flooring_product",
      key: "flooring_product",
      width: 140,
      render: (flooringType) => (
        <div className="table-info-block">
          <span>{flooringType === "BODYONLY" ? "BODY ONLY" : flooringType}</span>
        </div>
      ),
    },
    {
      title: "Veh/Chassis No",
      dataIndex: "vehicle_reg_no",
      key: "vehicle_reg_no",
      width: 140,
      render: (vehicle_reg_no, item) => (
        <div className="ven-block">
          <h2>{`${vehicle_reg_no == null ? "--" : vehicle_reg_no}`}</h2>
          <p>{`${item?.chassis_no}`}</p>
        </div>
      ),
    },
    {
      title: "Make/Model",
      dataIndex: "make_model",
      key: "make_model",
      width: 150,
      render: (makeModel) => (
        <div className="make-model-block">
          <h2>{`${makeModel}`}</h2>
        </div>
      ),
    },
    {
      title: "Floor Amt",
      dataIndex: "intended_floor_amount",
      key: "intended_floor_amount",
      width: 100,
      render: (intended_floor_amount) => (
        <div>
          <span>${intended_floor_amount.slice(
            0,
            intended_floor_amount.indexOf(".")
          )}</span>
        </div>
      ),
    },
    {
      title: "Case Exp",
      dataIndex: "expiry_date",
      key: "expiry_date",
      width: 100,
    },
    {
      title: "AAF Status",
      dataIndex: "cart",
      key: "cart",
      width: 120,
      render: (cart) => (
        <div className="table-Status-block">
          {cart?.agent_approved_status == 0 && (
            <span className={`status-pending`}>Pending</span>

          )}
          {cart?.agent_approved_status == 1 && (
            <span className={`status-issued`}>Issued</span>

          )}
          {cart?.agent_approved_status == 2 && (
            <span className={`status-rejected`}>Rejected</span>

          )}
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 120,
      render: (action, item) => (
        <div>
          <span
            className="view-resume-block"
            onClick={() => {
              navigate("/flooring-cases/view", {
                state: { appId: item?.id, submitted_date: item?.submitted_date, expiry_date: item?.expiry_date, pagePermission: pagePermission }
              });
            }}
          >
            <EyeOutlined className="mt-1" />
            <span>View</span>
          </span>
          {pagePermission?.delete_permission == 1 && (
            <span
              className="table-delete-block"
              onClick={() => {
                //console.log("click delete");
              }}
            >
              <DeleteOutlined className="mt-1" />
              <span>Delete</span>
            </span>
          )}
        </div>
      ),
    },
  ];

  return <Table dataSource={FlooringCases} columns={columns} scroll={{ x: "calc(400px + 50%)", y: 500 }} />;
};
